import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Grid,
  Snackbar,
  Paper,
} from "@mui/material";
import CashFreePayment from "../../components/payment/CashFreePayment";
import PayPalCheckout from "../../header/PayPalCheckout";
import instance from "../../Axios/axiosConfig";
import canvaImage from "../../assets/images/products/canvaImg.jpg";

const CanvaPremiumPage = () => {
  const [step, setStep] = useState(0);
  const [currency, setCurrency] = useState("INR");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [snackMessage, setSnackMessage] = useState("");

  useEffect(() => {
    setStep(0);
    setPhone("");
    setName(localStorage.getItem("name") || "");
    const storedEmail = localStorage.getItem("email");
    setEmail(storedEmail !== "null" ? storedEmail : "");
    resetForm();
  }, []);

  const isPhoneValid = () => {
    if (currency === "USD") return true;
    return /^[6-9]\d{9}$/.test(phone);
  };

  const isEmailValid = () => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleBuyClick = () => {
    setStep(1);
  };

  const resetForm = () => {
    setStep(0);
    setCurrency("INR");
    setPhone("");
    setName(localStorage.getItem("name") || "");
    const storedEmail = localStorage.getItem("email");
    setEmail(storedEmail !== "null" ? storedEmail : "");
  };
  

  const handlePaymentSuccess = async () => {
    try {
      await instance.post("/contact/addPremium", {
        name,
        email,
        phone,
      });
      setSnackMessage("Canva Premium activated successfully!, You will get the confirmation mail in 2 hrs");
      setStep(0);
      resetForm();
    } catch (error) {
      console.error("Error saving user info:", error);
      setSnackMessage("Payment succeeded, but something went wrong.");
    }
  };

  const renderStepIndicator = () => (
    <Box sx={{ textAlign: "center", mt: 3 }}>
      <Box sx={{ display: "inline-flex", gap: 2 }}>
        {[1, 2].map((num) => (
          <Box
            key={num}
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              backgroundColor: step + 1 === num ? "#2f80ed" : "gray",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
            }}
          >
            {num}
          </Box>
        ))}
      </Box>
    </Box>
  );

  return (
    <Box sx={{ maxWidth: "700px", mx: "auto", mt: 5, p: 2 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box
          component="img"
          src={canvaImage}
          alt="Canva Premium"
          sx={{
            display: "block",
            mx: "auto",
            maxWidth: "30%",
            borderRadius: 2,
            mb: 3,
          }}
        />

        <Typography variant="h4" align="center" gutterBottom>
          Canva Premium – Just {currency === "INR" ? "₹49" : "$0.50"} / year
        </Typography>
        <Typography variant="body1" align="center" mb={3}>
          Get unlimited access to premium templates, images, fonts, and more.
        </Typography>

        <TextField
          select
          fullWidth
          label="Select Currency"
          margin="normal"
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
        >
          <MenuItem value="INR">INR</MenuItem>
          <MenuItem value="USD">USD</MenuItem>
        </TextField>

        {step === 0 && (
          <Box textAlign="center" mt={3}>
            <Button variant="contained" color="primary" onClick={handleBuyClick}>
              Buy Now
            </Button>
          </Box>
        )}

        {step === 1 && (
          <>
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  type="tel"
                  placeholder={currency === "INR" ? "9876543210" : "Optional"}
                />
              </Grid>
            </Grid>

            <Box textAlign="center" mt={3}>
              {name && email && isEmailValid() && isPhoneValid() ? (
                currency === "INR" ? (
                  <CashFreePayment
                    amount={49}
                    phoneNumber={phone}
                    onSuccess={handlePaymentSuccess}
                  />
                ) : (
                  <PayPalCheckout Value={0.5} />
                )
              ) : (
                <Typography color="error" mt={1}>
                  Please fill all fields correctly.
                </Typography>
              )}
            </Box>

            {renderStepIndicator()}
          </>
        )}
      </Paper>

      <Snackbar
        open={!!snackMessage}
        autoHideDuration={3000}
        onClose={() => setSnackMessage("")}
        message={snackMessage}
      />
    </Box>
  );
};

export default CanvaPremiumPage;
